export default "__VITE_PUBLIC_ASSET__e36dd6c5__"